import { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { SvgInfo } from '@ui-kit'
import { Field, Props } from '../types/types'
import { APPLICATION_PREFERENCES_STRINGS } from '../utils/strings'

export const DuplicationScore = ({ groups }: Props) => {
  const [hovered, setHovered] = useState<boolean>(false)
  const [pos, setPos] = useState<{ top: number; left: number }>({
    top: 0,
    left: 0,
  })
  const iconRef = useRef<HTMLDivElement | null>(null)

  const totalScore = groups.reduce(
    (sum, g) => (g?.matched ? sum + g?.weight : sum),
    0
  )

  const formatFieldNames = (fields: Field[]) =>
    fields
      .map(
        (f) =>
          (f?.label || '').charAt(0).toUpperCase() + (f?.label || '').slice(1)
      )
      .join(' + ')

  useEffect(() => {
    if (hovered && iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect()
      const tooltipWidth = 240
      const tooltipHeight = 200
      const padding = 8

      let top = rect.top + window.scrollY
      let left = rect.left - tooltipWidth - padding + window.scrollX

      if (left < 0) {
        left = rect.right + padding + window.scrollX
      }

      const bottomOverflow =
        top + tooltipHeight - window.innerHeight + window.scrollY
      if (bottomOverflow > 0) {
        top = top - bottomOverflow - padding
      }

      setPos({ top, left })
    }
  }, [hovered])

  const tooltip =
    totalScore !== 0 ? (
      <div
        className="absolute z-[99999] bg-white text-black
                 border border-gray-300 rounded-lg p-3 w-60 text-sm
                 shadow-xl opacity-100"
        style={{
          top: pos.top,
          left: pos.left,
          position: 'absolute',
        }}
      >
        <div className="font-bold mb-2">
          {APPLICATION_PREFERENCES_STRINGS.MATCH_SCORE} : {totalScore}
        </div>
        {groups.map((g) => (
          <div key={g.groupName} className="mb-1">
            {g?.matched && g?.weight ? (
              <span>
                {' '}
                {formatFieldNames(g?.fields)} : {g?.matched ? g?.weight : 0}
              </span>
            ) : null}
          </div>
        ))}
      </div>
    ) : null

  return (
    <div
      ref={iconRef}
      className="inline-block"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <SvgInfo className="text-gray-400 cursor-pointer w-4 h-4" />
      {hovered && createPortal(tooltip, document.body)}
    </div>
  )
}
